import React from "react";
import { FormattedMessage } from "react-intl";
import ResultsBlock from "theme/components/molecules/ResultsBlock";
import AutocompleteResults, {
  AutocompleteOption,
} from "theme/components/organisms/Autocomplete/AutocompleteResults";
import ProductResultItem from "./ProductResultItem";

const ProductsResults = (props) => {
  return (
    <ResultsBlock
      title={
        <FormattedMessage
          id="modules.Search.SearchBar.ProductResults.title"
          defaultMessage="Products"
        />
      }
    >
      <AutocompleteResults>
        {props.results.map((result, index) => {
          return (
            <AutocompleteOption
              key={result.sku}
              id={`autocomplete-product-${result.sku}`}
              path={result.path}
              selected={props.selected}
              onSelect={props.onSelect}
            >
              <ProductResultItem result={result} />
            </AutocompleteOption>
          );
        })}
      </AutocompleteResults>
    </ResultsBlock>
  );
};

export default ProductsResults;
